module.exports = __webpack_public_path__ + "static/media/app-store-badge.bf54b4ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/static/images/app-store-badge.svg
// module id = 86
// module chunks = 1